import { Comment } from '@ant-design/compatible';
import { t } from '@hefe/i18n';
import {
  BasketballEventCommentPagination,
  BasketballEventType,
  UserBasic,
} from '@hefe/models';
import { BasketballGamesSlice, BasketballPracticesSlice } from '@hefe/store';
import { formatDateTime } from '@hefe/utils';
import { Button, Divider, Row } from 'antd';
import { useState } from 'react';
import { FiArrowUp } from 'react-icons/fi';
import { useAppDispatch } from '../../../../../store/store';
import CustomList from '../../../../core/components/custom-list/custom-list.component';
import UserAvatar from '../../../../core/components/user/user-avatar/user-avatar/user-avatar.component';
import EventDetailsCommentComposerComponent from './event-details-comments-composer/event-details-comments-composer.component';

interface EventDetailsCommentsComponentProps {
  comments?: BasketballEventCommentPagination;
  eventType: BasketballEventType;
  eventId: number;
  teamId: number;
  users: UserBasic[];
}

export default function EventDetailsCommentsComponent(
  props: EventDetailsCommentsComponentProps
) {
  const [loadMoreComments, setLoadMoreComments] = useState(false);

  const dispatch = useAppDispatch();
  const comments = props.comments || {
    current_page: 1,
    data: [],
    from: 0,
    to: 0,
    per_page: 10,
  };

  const fetchMoreComments = () => {
    setLoadMoreComments(true);
    if (props.eventType === BasketballEventType.GAME) {
      dispatch(
        BasketballGamesSlice.fetchBasketballGameTeamComments({
          gameId: props.eventId,
          teamId: props.teamId,
          page: comments.current_page + 1,
        })
      )
        .unwrap()
        .catch(() => null)
        .finally(() => setLoadMoreComments(false));
    }
    if (props.eventType === BasketballEventType.PRACTICE) {
      dispatch(
        BasketballPracticesSlice.fetchBasketballPracticeComments({
          practiceId: props.eventId,
          page: comments.current_page + 1,
        })
      )
        .unwrap()
        .catch(() => null)
        .finally(() => setLoadMoreComments(false));
    }
  };

  const renderLoadMoreButton = () => {
    if (!comments.next_page_url) {
      return;
    }

    return (
      <Row align="middle" justify="center">
        <Button
          loading={loadMoreComments}
          onClick={() => {
            fetchMoreComments();
          }}
        >
          {t('load_more.comments')}
          <FiArrowUp size={16} />
        </Button>
      </Row>
    );
  };

  return (
    <div>
      {renderLoadMoreButton()}
      <CustomList
        className="comment-list"
        itemLayout="horizontal"
        dataSource={[...comments.data].reverse()}
        renderItem={(item) => (
          <li>
            <Comment
              actions={[]}
              author={`${item.user?.firstname} ${item.user?.lastname}`}
              avatar={item.user ? <UserAvatar user={item.user} /> : null}
              content={item.text}
              datetime={formatDateTime(item.created_at || '', {
                withHypens: true,
              })}
            />
          </li>
        )}
      />
      <Divider />
      <EventDetailsCommentComposerComponent {...props} />
    </div>
  );
}
